function demo() {
  var email;
  var clientid;
  var signupdone;
  var xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function () {
    if (this.readyState == 4 && this.status == 200) {
      var myArr = JSON.parse(this.responseText);
      email = (myArr['data']['emailid']);
      clientid = (myArr['data']['clientid']);
      signupdone = (myArr['data']['signupdone']);
      if (email !== "1" && email !== null && signupdone === 1) {
        (function(b,o,n,g,s,r,c){if(b[s])return;b[s]={};b[s].scriptToken="Xy0zNTAxMzgwNTA";
          b[s].callsQueue=[];
          b[s].api=function(){b[s].callsQueue.push(arguments);};
          r=o.createElement(n);c=o.getElementsByTagName(n)[0];r.async=1;r.src=g;r.id=s+n;c.parentNode.insertBefore(r,c);
        })
        (window,document,'script','//cdn.oribi.io/Xy0zNTAxMzgwNTA/oribi.js','ORIBI');
        ORIBI.api('setUserEmail', email);


        (function (i, s, o, g, r, a, m) {
          i['GoogleAnalyticsObject'] = r;
          i[r] = i[r] || function () {
            (i[r].q = i[r].q || []).push(arguments)
          }, i[r].l = 1 * new Date();
          a = s.createElement(o),
            m = s.getElementsByTagName(o)[0];
          a.async = 1;
          a.src = g;
          m.parentNode.insertBefore(a, m)
        })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
        ga('create', 'UA-64829303-1', 'auto', {'userId': email});
        var dimensionValue = email;
        var dimensionValue1 = clientid;
        ga('require', 'displayfeatures');
        ga('set', 'dimension1', dimensionValue);
        ga('set', 'dimension2', dimensionValue1);
        ga('send', 'pageview');
        ga('send', 'event', 'signup', 'signupdone', 'signupdone', '1');
        resetSignupEmailId(email);
      }
    }
  };
  xhttp.open("GET", "https://cpaas.netcorecloud.com/index.php/userinfo/getSignupEmailId", true);
  xhttp.setRequestHeader("Content-type", "application/json");
  xhttp.send();


}


function resetSignupEmailId(emailAddress) {
  if (emailAddress !== "1") {
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        var myArr = JSON.parse(this.responseText);
      }
    };
    xhttp.open("GET", "https://cpaas.netcorecloud.com/index.php/userinfo/getSignupEmailId?flag=1", true);
    xhttp.setRequestHeader("Content-type", "application/json");
    xhttp.send();
  }
}
